<template>
  <div>
    <b-badge :variant="statusVariant" class="mr-1">
      {{ order.status_label }}
    </b-badge>
    <span v-if="order.refund_requested" class="text-warning whitespace-no-wrap">
      {{ $t('orders.refund_requested') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'OrderStatus',

  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    statusVariant() {
      switch (this.order.status) {
        case 'pending':
          return 'warning'
        case 'partial':
          return 'info'
        case 'completed':
          return 'success'
      }

      return 'light'
    },
  },
}
</script>
